import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { mapMutations,mapGetters, mapActions } from 'vuex';
import './utils/rem'
import 'normalize.css'
import 'swiper/dist/css/swiper.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vConsole from 'vconsole'
import weui from 'weui.js'
Vue.prototype.$weui = weui
if (location.origin.includes('qx1024')) {
  new vConsole()
}
Vue.use(ElementUI)
Vue.config.productionTip = false
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '7e2707620bdea65fb26813bd9ff6bd28',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale',
  'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor',
  'AMap.CircleEditor','AMap.Geolocation','AMap.Geocoder'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
// Vue.mixin({
//   computed: {
//     ...mapGetters(['user'])
//   },
//   methods: {
//     // ...mapMutations(['SET_OPENID','SET_POPENID','SET_USERID','SET_BUSINESSID',"SET_FROMID"]),
//   },
// })

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.name) {
    document.title = to.name
  }
  next();
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
